module.exports = __webpack_public_path__ + "static/media/EmpEssential.48f7ce09.svg";